export default "__VITE_ASSET__CDyhlKt1__"